import React, { useState } from "react";
import InvoicesPage from "@/pages/InvoicesPage";
import PurchaseOrdersPage from "@/pages/PurchaseOrdersPage";
import DamageItemsPage from "@/pages/DamageItemsPage";
import PurchaseReturnsPage from "@/pages/PurchaseReturnsPage";
import CashBookPage from "@/pages/CashBookPage";
import TablesPage from "@/pages/TablesPage";
import PriceBookPage from "@/pages/PriceBookPage";
import StockTakesPage from "@/pages/StockTakesPage";
import {
  FileText, ClipboardList, Trash2, Undo2, Wallet, DoorOpen, Tag, ClipboardCheck,
} from "lucide-react";

const TABS = [
  { key: "invoices", label: "Hóa đơn", icon: FileText },
  { key: "purchase-orders", label: "Phiếu nhập hàng", icon: ClipboardList },
  { key: "damage-items", label: "Phiếu xuất hủy", icon: Trash2 },
  { key: "purchase-returns", label: "Trả hàng nhập", icon: Undo2 },
  { key: "cashbook", label: "Sổ quỹ", icon: Wallet },
  { key: "tables", label: "Phòng/Bàn", icon: DoorOpen },
  { key: "pricebook", label: "Thiết lập giá", icon: Tag },
  { key: "stocktakes", label: "Kiểm kho", icon: ClipboardCheck },
];

export default function KiotVietMegaPage() {
  const [activeTab, setActiveTab] = useState("invoices");

  return (
    <div className="flex flex-col h-full" data-testid="kiotviet-mega-page">
      {/* Tabs Header */}
      <div className="flex items-center gap-0 border-b border-gray-200 dark:border-slate-700 bg-white dark:bg-slate-900 px-2 overflow-x-auto shrink-0 scrollbar-hide" style={{WebkitOverflowScrolling: 'touch'}}>
        {TABS.map(tab => {
          const Icon = tab.icon;
          return (
            <button
              key={tab.key}
              onClick={() => setActiveTab(tab.key)}
              className={`flex items-center gap-1.5 px-4 py-3 text-sm font-medium whitespace-nowrap border-b-2 transition-colors ${
                activeTab === tab.key
                  ? "border-blue-600 text-blue-600 dark:text-blue-400 dark:border-blue-400"
                  : "border-transparent text-gray-500 dark:text-slate-400 hover:text-gray-700 dark:hover:text-slate-300 hover:border-gray-300"
              }`}
              data-testid={`kv-tab-${tab.key}`}
            >
              <Icon className="w-4 h-4" />
              {tab.label}
            </button>
          );
        })}
      </div>

      {/* Tab Content */}
      <div className="flex-1 overflow-hidden">
        {activeTab === "invoices" && <InvoicesPage />}
        {activeTab === "purchase-orders" && <PurchaseOrdersPage />}
        {activeTab === "damage-items" && <DamageItemsPage />}
        {activeTab === "purchase-returns" && <PurchaseReturnsPage />}
        {activeTab === "cashbook" && <CashBookPage />}
        {activeTab === "tables" && <TablesPage />}
        {activeTab === "pricebook" && <PriceBookPage />}
        {activeTab === "stocktakes" && <StockTakesPage />}
      </div>
    </div>
  );
}
